export function parseJsonOrDefault(str, defaultResult) {
  try {
    return JSON.parse(str);
  } catch {
    return defaultResult;
  }
}
